export default "__VITE_ASSET__kvTYgEtl__"